import { AnalyticsPlugin } from "analytics";
import googleTagManager from "@analytics/google-tag-manager";
import { REACT_APP_GOOGLE_TAG_MANAGER_CONTAINER_ID } from "../../../utils";

export const GOOGLE_TAG_MANAGER_PLUGIN: AnalyticsPlugin = googleTagManager({
  containerId: REACT_APP_GOOGLE_TAG_MANAGER_CONTAINER_ID || "",
});
